<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="500">
    <v-card>
      <v-container>
        <v-row justify="center" align="center" class="flex-column">
          <v-avatar size="140" class="shadow">
            <v-img :src="student ? student.avatar : ''"></v-img>
          </v-avatar>
          <v-combobox
            v-model="selectedLevel"
            :items="data"
            item-text="name"
            item-value="uuid"
            multiple
            class="mt-10"
            dense
            outlined
            label="Current Level"
            @change="onChange"
          ></v-combobox>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import { getLevels, patchStudent } from "@/api/api";

export default {
  props: {
    value: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: [],
      selectedLevel: [],
    };
  },
  computed: {
    student: {
      set(value) {
        this.$store.commit("admin/student", value);
      },
      get() {
        return this.$store.getters["admin/student"];
      },
    },
  },
  methods: {
    async onChange(e) {
      const response = await patchStudent({
        uuid: this.student.uuid,
        level: e.map((level) => level.uuid),
      });
      if (response) {
        this.$emit("update-student", response.data);
        this.student = response.data;
      }
    },
  },
  watch: {
    value(val) {
      if (val && this.student) {
        this.selectedLevel = [];
        this.student.level.forEach((level) => {
          const index = this.data.findIndex((item) => item.uuid === level);
          if (index !== -1) {
            this.selectedLevel.push(this.data[index]);
          }
        });
      } else if (!val) {
        this.selectedLevel = [];
      }
    },
  },
  async created() {
    const response = await getLevels();

    if (response) {
      this.data = response.data;
    }
  },
};
</script>
